module.exports = __webpack_public_path__ + "static/CRV-843511eeaaed4a7d3a934939f11c78c5.svg";